import { updateLinksAttributes } from '../utils/handleAttributes';
const wrapContainerClass = 'sponsorsOfTheDay-wrap-container';

export default function sponsorsOfTheDay() {
  const widgetName = 'sponsorsOfTheDay';
  const widgetOpts = sponsorsOfTheDayOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: false,
    maxItemsVisible: 10,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createsponsorsOfTheDay(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createsponsorsOfTheDay(widgetData) {
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $cardItem = $(this);

      validateUrl(URL, $cardItem);
      updateLinksAttributes(URL, Title, $cardItem);
    });
  }
}

function validateUrl(url, $cardItem) {
  if ($cardItem && url === null) {
    $cardItem.addClass('void-url');
  }
  return url !== null;
}
